import(/* webpackMode: "eager" */ "/codebuild/output/src3798680965/src/front_alegria/src/app/global-error.tsx");
